import React from "react";

const CarePlansIcon = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.1732 31.749H3.83989C3.47189 31.749 3.17323 31.4503 3.17323 31.0823V3.08232C3.17323 2.71432 3.47189 2.41565 3.83989 2.41565H29.1732C29.5412 2.41565 29.8399 2.71432 29.8399 3.08232V31.0823C29.8399 31.4503 29.5412 31.749 29.1732 31.749Z"
      fill="#C6A279"
    />
    <path
      d="M26.5066 29.0823H6.50656C6.13856 29.0823 5.83989 28.7837 5.83989 28.4157V5.74899C5.83989 5.38099 6.13856 5.08232 6.50656 5.08232H26.5066C26.8746 5.08232 27.1732 5.38099 27.1732 5.74899V28.4157C27.1732 28.7837 26.8746 29.0823 26.5066 29.0823Z"
      fill="#E6E6E6"
    />
    <path
      d="M21.8399 7.74899H19.1732C18.8052 7.74899 18.5066 7.45032 18.5066 7.08232C18.5066 5.97965 17.6092 5.08232 16.5066 5.08232C15.4039 5.08232 14.5066 5.97965 14.5066 7.08232C14.5066 7.45032 14.2079 7.74899 13.8399 7.74899H11.1732C10.8052 7.74899 10.5066 7.45032 10.5066 7.08232V1.74899C10.5066 1.38099 10.8052 1.08232 11.1732 1.08232H21.8399C22.2079 1.08232 22.5066 1.38099 22.5066 1.74899V7.08232C22.5066 7.45032 22.2079 7.74899 21.8399 7.74899Z"
      fill="#B3B3B3"
    />
    <path
      d="M19.8399 16.4157H17.8399V14.4157C17.8399 14.0477 17.5412 13.749 17.1732 13.749H15.8399C15.4719 13.749 15.1732 14.0477 15.1732 14.4157V16.4157H13.1732C12.8052 16.4157 12.5066 16.7143 12.5066 17.0823V18.4157C12.5066 18.7837 12.8052 19.0823 13.1732 19.0823H15.1732V21.0823C15.1732 21.4503 15.4719 21.749 15.8399 21.749H17.1732C17.5412 21.749 17.8399 21.4503 17.8399 21.0823V19.0823H19.8399C20.2079 19.0823 20.5066 18.7837 20.5066 18.4157V17.0823C20.5066 16.7143 20.2079 16.4157 19.8399 16.4157Z"
      fill="#E86C60"
    />
  </svg>
);

const EmarIcon = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_509_2351)">
      <path
        d="M12.8149 3.64389C14.1933 2.28385 16.0536 1.52419 17.99 1.53067C19.9264 1.53716 21.7817 2.30927 23.1509 3.67852C24.5202 5.04776 25.2923 6.903 25.2988 8.8394C25.3052 10.7758 24.5456 12.6362 23.1855 14.0146L13.8522 23.3479C12.4738 24.7079 10.6134 25.4676 8.67705 25.4611C6.74065 25.4546 4.88541 24.6825 3.51616 23.3133C2.14692 21.944 1.37481 20.0888 1.36832 18.1524C1.36183 16.216 2.12149 14.3556 3.48154 12.9772L12.8149 3.64389Z"
        fill="#F888C0"
      />
      <path
        d="M23.1855 3.64389C21.8103 2.2687 19.9451 1.49612 18.0002 1.49612C16.0553 1.49612 14.1901 2.2687 12.8149 3.64389L8.1482 8.31056L18.5189 18.6812L23.1855 14.0146C24.5607 12.6393 25.3333 10.7741 25.3333 8.82923C25.3333 6.88436 24.5607 5.01915 23.1855 3.64389Z"
        fill="#FFE699"
      />
      <path
        d="M23.3335 32.1626C28.12 32.1626 32.0002 28.2824 32.0002 23.4959C32.0002 18.7094 28.12 14.8292 23.3335 14.8292C18.5471 14.8292 14.6669 18.7094 14.6669 23.4959C14.6669 28.2824 18.5471 32.1626 23.3335 32.1626Z"
        fill="#E3E3E3"
      />
      <path
        d="M4.89554 22.6006C4.80796 22.6008 4.7212 22.5837 4.6403 22.5501C4.55939 22.5166 4.48594 22.4673 4.4242 22.4052C3.3006 21.2791 2.66957 19.7533 2.66957 18.1626C2.66957 16.5718 3.3006 15.046 4.4242 13.9199C4.54994 13.7985 4.71834 13.7313 4.89314 13.7328C5.06794 13.7343 5.23514 13.8044 5.35875 13.928C5.48235 14.0516 5.55247 14.2188 5.55399 14.3936C5.55551 14.5684 5.48831 14.7368 5.36687 14.8626C4.49307 15.7385 4.00235 16.9253 4.00235 18.1626C4.00235 19.3998 4.49307 20.5866 5.36687 21.4626C5.46008 21.5558 5.52355 21.6746 5.54926 21.8039C5.57497 21.9332 5.56177 22.0672 5.51132 22.189C5.46088 22.3108 5.37545 22.4149 5.26584 22.4882C5.15624 22.5614 5.02737 22.6005 4.89554 22.6006Z"
        fill="#FDDDED"
      />
      <path
        d="M18.6669 28.8292C18.535 28.8292 18.4062 28.7901 18.2966 28.7168C18.187 28.6436 18.1015 28.5395 18.0511 28.4177C18.0006 28.2959 17.9874 28.1618 18.0131 28.0325C18.0389 27.9032 18.1023 27.7845 18.1955 27.6912L27.5289 18.3579C27.6546 18.2365 27.823 18.1693 27.9978 18.1708C28.1726 18.1723 28.3398 18.2424 28.4634 18.366C28.587 18.4896 28.6571 18.6568 28.6587 18.8316C28.6602 19.0064 28.593 19.1748 28.4715 19.3006L19.1382 28.6339C19.0132 28.7589 18.8437 28.8292 18.6669 28.8292Z"
        fill="#C8C8C8"
      />
    </g>
    <defs>
      <clipPath id="clip0_509_2351">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.66687 0.829224)"
        />
      </clipPath>
    </defs>
  </svg>
);
const FamilyIcon = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.3172 17.1183C30.1724 15.6366 29.4803 14.2622 28.3762 13.2636C27.2721 12.265 25.8353 11.714 24.3466 11.7183H19.9999C18.5112 11.714 17.0744 12.265 15.9703 13.2636C14.8662 14.2622 14.1741 15.6366 14.0292 17.1183L13.1766 25.6516C13.1672 25.7443 13.1775 25.8379 13.2066 25.9264C13.2356 26.0149 13.283 26.0964 13.3455 26.1655C13.408 26.2346 13.4843 26.2898 13.5694 26.3276C13.6546 26.3654 13.7467 26.3849 13.8399 26.3849H30.5066C30.6 26.3854 30.6925 26.3662 30.7781 26.3286C30.8636 26.291 30.9403 26.2359 31.0032 26.1667C31.0661 26.0976 31.1137 26.016 31.143 25.9272C31.1723 25.8385 31.1826 25.7446 31.1732 25.6516L30.3172 17.1183Z"
      fill="#2A4B55"
    />
    <path
      d="M22.1732 10.3849C24.5665 10.3849 26.5066 8.44483 26.5066 6.05159C26.5066 3.65836 24.5665 1.71826 22.1732 1.71826C19.78 1.71826 17.8399 3.65836 17.8399 6.05159C17.8399 8.44483 19.78 10.3849 22.1732 10.3849Z"
      fill="#2A4B55"
    />
    <path
      d="M18.9839 17.1183C18.8391 15.6366 18.147 14.2622 17.0428 13.2636C15.9387 12.265 14.5019 11.714 13.0132 11.7183H8.66656C7.17786 11.714 5.74106 12.265 4.63694 13.2636C3.53283 14.2622 2.84073 15.6366 2.69589 17.1183L1.84323 25.6516C1.83391 25.7443 1.84413 25.8379 1.87322 25.9264C1.90232 26.0149 1.94964 26.0964 2.01214 26.1655C2.07464 26.2346 2.15093 26.2898 2.23609 26.3276C2.32125 26.3654 2.41339 26.3849 2.50656 26.3849H19.1732C19.2667 26.3854 19.3592 26.3662 19.4447 26.3286C19.5303 26.291 19.607 26.2359 19.6699 26.1667C19.7327 26.0976 19.7803 26.016 19.8096 25.9272C19.8389 25.8385 19.8492 25.7446 19.8399 25.6516L18.9839 17.1183Z"
      fill="#3D6C7B"
    />
    <path
      d="M16.5066 23.7183C18.7157 23.7183 20.5066 21.9274 20.5066 19.7183C20.5066 17.5091 18.7157 15.7183 16.5066 15.7183C14.2974 15.7183 12.5066 17.5091 12.5066 19.7183C12.5066 21.9274 14.2974 23.7183 16.5066 23.7183Z"
      fill="#A0E6EE"
    />
    <path
      d="M26.8366 20.1656C26.7202 20.0347 26.5792 19.928 26.4217 19.8516C26.2641 19.7752 26.093 19.7305 25.9182 19.7203C25.7433 19.71 25.5682 19.7342 25.4027 19.7917C25.2373 19.8491 25.0848 19.9385 24.9539 20.0549L19.3326 25.0516H13.6806L8.05923 20.0516C7.92834 19.9352 7.77582 19.8458 7.61038 19.7884C7.44493 19.731 7.2698 19.7067 7.09497 19.717C6.92015 19.7273 6.74907 19.7719 6.59149 19.8483C6.4339 19.9247 6.29291 20.0314 6.17656 20.1623C6.06021 20.2931 5.97078 20.4457 5.91337 20.6111C5.85596 20.7766 5.83171 20.9517 5.84198 21.1265C5.85226 21.3013 5.89687 21.4724 5.97326 21.63C6.04966 21.7876 6.15634 21.9286 6.28723 22.0449L11.8399 26.9849V30.3849C11.8399 30.5617 11.9101 30.7313 12.0352 30.8563C12.1602 30.9814 12.3298 31.0516 12.5066 31.0516H20.5066C20.6834 31.0516 20.8529 30.9814 20.978 30.8563C21.103 30.7313 21.1732 30.5617 21.1732 30.3849V26.9849L26.7259 22.0516C26.8573 21.9352 26.9644 21.794 27.0411 21.6362C27.1178 21.4783 27.1626 21.3068 27.1729 21.1316C27.1832 20.9563 27.1588 20.7808 27.101 20.615C27.0433 20.4493 26.9534 20.2965 26.8366 20.1656Z"
      fill="#A0E6EE"
    />
    <path
      d="M10.8399 10.3849C13.2331 10.3849 15.1732 8.44483 15.1732 6.05159C15.1732 3.65836 13.2331 1.71826 10.8399 1.71826C8.44666 1.71826 6.50656 3.65836 6.50656 6.05159C6.50656 8.44483 8.44666 10.3849 10.8399 10.3849Z"
      fill="#3D6C7B"
    />
  </svg>
);
const GroupsIcon = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9665 20.6553L16.8399 16.0566V10.0563H14.1732V16.0566L8.0466 20.6553L9.64751 22.7881L15.5065 18.3902L21.3656 22.7881L22.9665 20.6553Z"
      fill="#335262"
    />
    <path
      d="M15.5066 11.3896C18.4521 11.3896 20.8399 9.00183 20.8399 6.05631C20.8399 3.11079 18.4521 0.722977 15.5066 0.722977C12.561 0.722977 10.1732 3.11079 10.1732 6.05631C10.1732 9.00183 12.561 11.3896 15.5066 11.3896Z"
      fill="#43A6DD"
    />
    <path
      d="M6.17323 30.0563C9.11875 30.0563 11.5066 27.6685 11.5066 24.723C11.5066 21.7775 9.11875 19.3896 6.17323 19.3896C3.22771 19.3896 0.839893 21.7775 0.839893 24.723C0.839893 27.6685 3.22771 30.0563 6.17323 30.0563Z"
      fill="#43A6DD"
    />
    <path
      d="M24.8399 30.0563C27.7854 30.0563 30.1732 27.6685 30.1732 24.723C30.1732 21.7775 27.7854 19.3896 24.8399 19.3896C21.8944 19.3896 19.5066 21.7775 19.5066 24.723C19.5066 27.6685 21.8944 30.0563 24.8399 30.0563Z"
      fill="#43A6DD"
    />
  </svg>
);
const ProIcon = (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.47661 15.6691C8.29953 15.6691 8.13026 15.5988 8.00526 15.4738L3.43495 10.9035C3.2201 10.6886 3.17779 10.3553 3.33208 10.0936C3.83208 9.24558 4.41802 8.48353 5.07361 7.82793C8.37765 4.5239 13.2852 3.58379 17.5749 5.43177C17.7774 5.51901 17.9232 5.70033 17.9655 5.91648C18.0079 6.1323 17.9408 6.35528 17.7859 6.51218L8.95123 15.4705C8.82688 15.5971 8.65631 15.6684 8.47922 15.6691C8.47791 15.6691 8.47726 15.6691 8.47661 15.6691Z"
      fill="#B3B3B3"
    />
    <path
      d="M22.2683 29.4608C22.0958 29.4608 21.9252 29.394 21.7969 29.2654L17.1862 24.6548C17.0606 24.5294 16.9903 24.3592 16.9909 24.1815C16.9916 24.004 17.0625 23.8341 17.1889 23.7094L26.155 14.8406C26.3113 14.6863 26.5333 14.6196 26.7487 14.6596C26.9642 14.7007 27.1459 14.8452 27.2338 15.046C29.1303 19.3576 28.2032 24.296 24.8724 27.6271C24.2181 28.2817 23.4558 28.8673 22.6068 29.3683C22.5014 29.4305 22.3848 29.4608 22.2683 29.4608Z"
      fill="#B3B3B3"
    />
    <path
      d="M5.86919 18.4217C5.76959 18.6697 5.82753 18.953 6.01633 19.1418L13.5586 26.6841C13.6863 26.8117 13.8568 26.8794 14.03 26.8794C14.1153 26.8794 14.2006 26.8631 14.2826 26.8299C14.4083 26.7784 23.9993 22.7257 28.8993 12.5869L20.0815 3.76907C9.9264 8.65591 5.91973 18.2956 5.86919 18.4217Z"
      fill="#E6E6E6"
    />
    <path
      d="M31.4734 1.22931C31.3392 1.09454 31.1439 1.02195 30.9662 1.03399C26.7388 1.25457 23.1354 2.29945 20.0815 3.76906L28.8993 12.5869C30.3729 9.53807 31.4272 5.94545 31.6661 1.73745C31.6771 1.54832 31.6068 1.36375 31.4734 1.22931Z"
      fill="#E86C60"
    />
    <path
      d="M18.7435 17.2879C17.89 17.2879 17.0365 16.963 16.3868 16.3133C15.0873 15.0138 15.0873 12.8989 16.3868 11.5994C17.6869 10.2986 19.8021 10.2999 21.101 11.5994C21.7305 12.229 22.0775 13.0659 22.0775 13.9562C22.0775 14.8468 21.7305 15.6837 21.101 16.3133C20.4512 16.963 19.5977 17.2879 18.7435 17.2879Z"
      fill="#76B5B5"
    />
    <path
      d="M4.18039 30.2293C3.6908 30.2293 3.30343 30.2056 3.12375 30.1922C2.79432 30.1678 2.5326 29.9061 2.50851 29.5767C2.46099 28.9396 2.28586 25.7007 3.48312 24.5037C4.11268 23.8742 4.94927 23.5275 5.83989 23.5275C6.73052 23.5275 7.56711 23.8742 8.19667 24.5037C9.49615 25.8035 9.49615 27.9181 8.19667 29.2179C7.33794 30.077 5.42648 30.2293 4.18039 30.2293Z"
      fill="#EA9860"
    />
  </svg>
);

const OutstandingIcon = (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4938 18.9365L15.7501 14.6252V9H13.2501V14.6253L7.50635 18.9365L9.0072 20.936L14.5 16.813L19.9929 20.936L21.4938 18.9365Z"
      fill="#335262"
    />
    <path
      d="M14.5 10.25C17.2614 10.25 19.5 8.01142 19.5 5.25C19.5 2.48858 17.2614 0.25 14.5 0.25C11.7386 0.25 9.5 2.48858 9.5 5.25C9.5 8.01142 11.7386 10.25 14.5 10.25Z"
      fill="#43A6DD"
    />
    <path
      d="M5.75 27.75C8.51142 27.75 10.75 25.5114 10.75 22.75C10.75 19.9886 8.51142 17.75 5.75 17.75C2.98858 17.75 0.75 19.9886 0.75 22.75C0.75 25.5114 2.98858 27.75 5.75 27.75Z"
      fill="#43A6DD"
    />
    <path
      d="M23.25 27.75C26.0114 27.75 28.25 25.5114 28.25 22.75C28.25 19.9886 26.0114 17.75 23.25 17.75C20.4886 17.75 18.25 19.9886 18.25 22.75C18.25 25.5114 20.4886 27.75 23.25 27.75Z"
      fill="#43A6DD"
    />
  </svg>
);

const StarterIcon = (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.75 1.25C19.3153 1.25 17.0369 2.33368 15.5 4.1864C13.9631 2.33368 11.6847 1.25 9.25 1.25C4.77002 1.25 1.125 4.89471 1.125 9.375C1.125 17.0825 14.5332 28.1418 15.1045 28.6087C15.2192 28.703 15.3596 28.75 15.5 28.75C15.6404 28.75 15.7808 28.703 15.8955 28.6087C16.4668 28.1418 29.875 17.0825 29.875 9.375C29.875 4.89471 26.23 1.25 21.75 1.25Z"
      fill="#E86C60"
    />
  </svg>
);

const RosteringIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 37"
    fill="none"
  >
    <g clip-path="url(#clip0_7492_198188)">
      <rect y="3" width="33" height="30" rx="4" fill="#E6E6E6" />
      <path
        d="M0 7C0 4.79086 1.79086 3 4 3H29C31.2091 3 33 4.79086 33 7V10H0V7Z"
        fill="#E86C60"
      />
      <rect x="6" width="3" height="7" rx="1" fill="#333333" />
      <rect x="24" width="3" height="7" rx="1" fill="#333333" />
      <path
        d="M16.5 28C16.5988 28.0001 16.6966 27.9813 16.7878 27.9449C16.879 27.9084 16.9619 27.8549 17.0316 27.7875L22.7029 22.3011C23.5277 21.5046 23.9937 20.4269 23.9999 19.3015C24.0062 18.1761 23.5522 17.0936 22.7363 16.2886C21.9205 15.4836 20.8084 15.0209 19.6411 15.0007C18.4738 14.9805 17.3453 15.4045 16.5 16.1807C15.6546 15.4044 14.526 14.9805 13.3586 15.0007C12.1912 15.021 11.0791 15.4838 10.2633 16.289C9.44746 17.0941 8.99361 18.1767 9.00007 19.3022C9.00653 20.4277 9.47279 21.5054 10.2978 22.3018L15.9683 27.7882C16.0381 27.8555 16.121 27.9089 16.2123 27.9452C16.3035 27.9815 16.4013 28.0002 16.5 28Z"
        fill="#E86C60"
      />
    </g>
    <defs>
      <clipPath id="clip0_7492_198188">
        <rect width="33" height="33" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Icons = {
  CarePlansIcon,
  EmarIcon,
  FamilyIcon,
  GroupsIcon,
  ProIcon,
  OutstandingIcon,
  StarterIcon,
  RosteringIcon,
};

export default Icons;
